"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrosiveRain = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const CorrosiveRainDeferredAction_1 = require("../../deferredActions/CorrosiveRainDeferredAction");
class CorrosiveRain {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.CORROSIVE_RAIN;
        this.description = 'Lose 2 floaters from a card or 10 M€. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            player.drawCard(turmoil.getPlayerInfluence(player));
            game.defer(new CorrosiveRainDeferredAction_1.CorrosiveRainDeferredAction(player));
        });
    }
}
exports.CorrosiveRain = CorrosiveRain;
//# sourceMappingURL=CorrosiveRain.js.map